import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

export interface GetServiceListResponse {
  // adService: number
  // apiType: number
  // companyLocation: string
  companyName: string
  // geoFenceFlag: number
  // imageID: number
  // inboundService: number
  // ljAudienceFlag: boolean
  // ljLineFlag: boolean
  // ljSdkFlag: boolean
  // ljWeatherFlag: boolean
  name: string
  // raBeaconEnabled: boolean
  // raCameraEnabled: boolean
  // raEnabledFlag: boolean
  // raPosEnabled: boolean
  // raRfidEnabled: boolean
  // raWifiEnabled: boolean
  serviceID: number
  planType: number
  // visit: number
}

const useGetServiceList = () => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetServiceListResponse[]> => axios.get(url).then((res) => res.data.services)
  const { data, isLoading } = useSWR(
    () => accessToken && `${process.env.REACT_APP_API_DOMAIN}/1/Console/GetServiceList?accessToken=${accessToken}`,
    fetcher,
    { revalidateOnFocus: false, revalidateOnReconnect: false, shouldRetryOnError: false },
  )

  return { services: data, isLoading }
}

export default useGetServiceList
